<div class="c-toast__body {{ item.toast.type }}"
    *ngFor="let item of toasts; trackBy: trackIdFn"
    (click)="close(item)"
    #toast>
    <div class="c-toast__left">
        <pay-icon [name]="ICONS[item.toast.type]" class="c-icon--md x-toast-icon {{ item.toast.type }}"></pay-icon>
    </div>
    <div class="c-toast__message-wrapper">
        <div class="c-toast__title">
            {{ item.toast.msg | translate }}
        </div>
        <div class="c-toast__subtitle" *ngIf="item.toast?.subtitle">
            {{ item.toast.subtitle | translate }}
        </div>
    </div>
</div>